module.exports = __webpack_public_path__ + "img/de.58f022d3.svg";